import { render, staticRenderFns } from "./Handle.vue?vue&type=template&id=13c1164c&"
import script from "./Handle.vue?vue&type=script&lang=ts&"
export * from "./Handle.vue?vue&type=script&lang=ts&"
import style0 from "./Handle.vue?vue&type=style&index=0&id=13c1164c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports